import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';
import _ from 'lodash';

export class IsfListItem extends SearchModelBase {
    userId: string = '';
    status: string = '';
    disp: string = '';
    lastAction: string = '';
    isfNo: string = '';
    shipmentId: string = '';
    impName: string = '';
    impNo: string = '';
    hblNo: string = '';
    tariffNo: string = '';
    branch: string = '';
    etd: string | null = null;
    fromEtd: string | null = null;
    toEtd: string | null = null;
    isfDate: string | null = null;
    fromIsfDate: string | null = null;
    toIsfDate: string | null = null;
    bondHolder: string = '';
    createdBy: string = '';
    createDate: string | null = null;
    fromCreateDate: string | null = null;
    toCreateDate: string | null = null;
    modifiedBy: string = '';
    modifyDate: string | null = null;
    fromModifyDate: string | null = null;
    toModifyDate: string | null = null;
    id: number = 0;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'stat', hiddenInColumnSetup: true, filterable: false }),
        XCol.Create({ col: 1, text: 'User ID', width: 80, dataIndex: 'userId'}),
        XCol.Create({ col: 2, text: 'Status', width: 200, dataIndex: 'status'}),
        XCol.Create({ col: 3, text: 'BR', width: 40, dataIndex: 'branch'}),
        XCol.Create({ col: 4, text: 'Disp', width: 60, dataIndex: 'disp'}),
        XCol.Create({ col: 5, text: 'Last Action', width: 100, dataIndex: 'lastAction'}),
        XCol.Create({ col: 6, text: 'ISF #', width: 100, dataIndex: 'isfNo', defaultColumnFocus : true}),
        XCol.Create({ col: 7, text: 'Shipment ID', width: 100, dataIndex: 'shipmentId'}),
        XCol.Create({ col: 8, text: 'Importer Name', width: 150, dataIndex: 'impName'}),
        XCol.Create({ col: 9, text: 'Importer #', width: 100, dataIndex: 'impNo'}),
        XCol.Create({ col: 10, text: 'HBL #', width: 100, dataIndex: 'hblNo'}),
        XCol.Create({ col: 11, text: 'HTS Code', width: 100, dataIndex: 'tariffNo'}),
        XCol.Create({ col: 12, text: 'ETD', width: 75, dataIndex: 'etd', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 13, text: 'ISF Date', width: 75, dataIndex: 'isfDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 14, text: 'Bond Holder', width: 150, dataIndex: 'bondHolder'}),
        XCol.Create({ col: 15, text: 'Create by', width: 150, dataIndex: 'createdBy'}), 
        ];


    public static getExportCollection(useBranch: boolean): XCol.XExportColumn[] {
        let returnCloumns = _.cloneDeep(this.ExportCollection);
        if (!useBranch) returnCloumns = returnCloumns.filter(x => x.dataIndex !== 'branch');
        return returnCloumns;
    };
	
    public static OrderBy = { orderBy: IsfListItem.prototype.id, orderByAscending: false };

    public static formatData(data: IsfListItem[]) {
        return data.map((d: IsfListItem) => ({
          ...d,
        }));
    }
    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        etd: {from: 'fromEtd', to: 'toEtd'},
        isfDate: {from: 'fromIsfDate', to: 'toIsfDate'},
        modifyDate: {from: 'fromModifyDate', to: 'toModifyDate'},
    }
}
